import { apiInstance } from '@shared/api'

export const postEmbeddedSignRequest = async () => {
  const res = await apiInstance.post<EmbeddedSignRequestResponse>(
    '/api/v1/sign/embedded/request',
    {},
  )
  return res.data
}
